import React from 'react';
import PropTypes from 'prop-types';
import find from 'lodash/find';
import { Badge, SelectMenu } from '@decisiv/ui-components';
import { BADGE_SIZE, BadgeSlot, Wrapper } from './style';

export default function DecoratedSelectMenu(props) {
  const { options, selected } = props;
  const option = find(options, { id: selected });
  const { type, ...badge } = option?.decoration ?? {};
  const decorated = type === 'Badge';

  return (
    <Wrapper decorated={decorated}>
      <SelectMenu {...props} />
      {decorated && (
        <BadgeSlot aria-hidden="true">
          <Badge
            {...badge}
            aria-label={option.label}
            size={BADGE_SIZE}
            variant="square"
          />
        </BadgeSlot>
      )}
    </Wrapper>
  );
}

DecoratedSelectMenu.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      label: PropTypes.string,
      decoration: PropTypes.shape({ type: PropTypes.string }),
    }),
  ).isRequired,
  selected: PropTypes.string.isRequired,
};
